import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { tap, take, switchMap, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { Store } from '@ngrx/store';
import * as fromStore from '@usimweb/state/store';

@Injectable()
export class ResultGuard {
  constructor(private store: Store<fromStore.DashboardState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.checkStore(route).pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.store.select(fromStore.getResultLoaded).pipe(
      tap((loaded) => {
        //if (!loaded) {
        const id = route.params['id'];
        const id2 = route.params['id2'];

        this.store.dispatch(new fromStore.LoadResult({ uuid: id2, filling: 'filling' }));
        this.store.dispatch(new fromStore.LoadProject(id));
        this.store.dispatch(new fromStore.LoadVersions(id));
        //}
      }),
      // unsubscribe the observable if loaded true
      // filter((loaded) => loaded === true),
      take(1)
    );
  }
}
